<template>
  <v-expansion-panel
    class="marge-bas"
  >
    <v-expansion-panel-header
      class="titre-panneau"
      style="color:white;background-color:rgb(9, 87, 151)"
      v-on:click="onPanelChange(!estPanneauOuvert)"
    >
      {{ titre }}

      <template v-slot:actions>
        <p v-if="estPanneauOuvert" class="ma-0">{{ $t('general.afficherMoins')}}</p>
        <p v-else class="ma-0">{{ $t('general.afficherPlus')}}</p>
      </template>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <slot></slot>

      <v-btn
        v-if="afficherBtn"
        class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary btn-action"
        v-on:click="btnClick"
        :disabled="btnDisabled"
      >
        {{ btnTexte }}
      </v-btn>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'PanneauExtension',
  props: {
    titre: {
      type: String,
      default: '',
    },
    afficherBtn: {
      type: Boolean,
      default: false,
    },
    btnTexte: {
      type: String,
      default: '',
    },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      estPanneauOuvert: false,
    };
  },
  methods: {
    btnClick() {
      this.$emit('btn-click');
    },
    onPanelChange(estOuvert) {
      this.estPanneauOuvert = estOuvert;
    },
  },
};
</script>

<style scoped>
.titre-panneau {
  font-size: 1rem;
  font-weight: bold;
}

.btn-action {
  margin-top: 1rem;
  float: right;
}

.marge-bas {
  margin-bottom: 1.75rem;
}

.titre-panneau::v-deep > div > i::before {
  color: #fff !important;
}
</style>
